export const BuilderConfig = {
  DebounceDelay: 1000,
}
